module.exports = __webpack_public_path__ + "static/media/profile1.c9a289e7.jpg";